import React from "react";
import { Badge, Card, Col, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { ChevronRight } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import { HeaderLabel, SubHeaderLabel } from "../Labels.tsx";
import { ProjectDetails } from "../ProjectDetails/ProjectDetails.types.tsx";

import { isDraft } from "../../services/project.services.tsx";
import { useHomeContext } from "../../views/Home/HomeView.context.tsx";

const ProjectsFormUI: React.FC = () => {
  const { t } = useTranslation();

  const {
    uuid: activeProjectUuid,
    projects,
    setUuid,
    isLoading,
    loadingComponent,
    showOnlyDrafts,
    setDraftsFilter,
  } = useHomeContext();

  if (isLoading) return loadingComponent;

  return (
    <Col xs={12} md={5} className="p-0">
      <div className="m-4">
        <div className="p-4 rounded-4 d-flex flex-column gap-3 projectsContainer">
          <HeaderLabel textAlign="left">{t("projects.title")}</HeaderLabel>

          {/* Esta pantalla no habla con workflow, así que puede decir SI una hoja está en un
              proyecto pero no en cuál. Eso basta para lo que hace falta: saber cuál se descarta. */}
          <ToggleButtonGroup
            type="radio"
            name="draftsFilter"
            value={showOnlyDrafts ? "drafts" : "all"}
            onChange={(value: string) => setDraftsFilter(value === "drafts")}
          >
            <ToggleButton id="filter-all" value="all" variant="outline-secondary" size="sm">
              {t("projects.filterAll")}
            </ToggleButton>

            <ToggleButton id="filter-drafts" value="drafts" variant="outline-secondary" size="sm">
              {t("projects.filterDrafts")}
            </ToggleButton>
          </ToggleButtonGroup>

          {projects?.length === 0 && <SubHeaderLabel>{t("projects.empty")}</SubHeaderLabel>}

          {projects?.map((project: ProjectDetails) => {
            const { uuid, name, description, created_at } = project;
            const draft = isDraft(project);
            const date = new Date(created_at);

            const formattedDate = `${date.toLocaleString("en-US", {
              month: "short",
            })}/${String(date.getDate()).padStart(2, "0")}/${date.getFullYear()}`;

            return (
              <Card
                key={uuid}
                onClick={() => setUuid(uuid)}
                className={`shadow-sm pointer-div ${
                  activeProjectUuid === uuid ? "active-project" : ""
                }`}
              >
                <Card.Body>
                  <Card.Title className="d-flex justify-content-between align-items-center">
                    {name}
                    <ChevronRight />
                  </Card.Title>

                  {description && <Card.Text>{description}</Card.Text>}

                  <Card.Text className="d-flex justify-content-between align-items-center small mb-0">
                    <Badge bg={draft ? "secondary" : "success"}>
                      {draft ? t("projects.draft") : t("projects.adopted")}
                    </Badge>

                    <span>
                      {t("projects.created")} {formattedDate}
                    </span>
                  </Card.Text>
                </Card.Body>
              </Card>
            );
          })}
        </div>
      </div>
    </Col>
  );
};

export default ProjectsFormUI;
